(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHero = (hero) => {
      if (!hero || hero.dataset.carouselInitialized === 'true') return;
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-hero-dot]')];
      const toggle = hero.querySelector('[data-hero-toggle]');
      if (slides.length < 2) return;

      hero.dataset.carouselInitialized = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Number(hero.dataset.autoplayDelay) || 5000;
      let index = 0;
      let timer;
      let manuallyPaused = false;

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
      };

      const stop = () => window.clearInterval(timer);
      const play = () => {
        stop();
        if (!manuallyPaused && !reduceMotion.matches && !document.hidden) {
          timer = window.setInterval(() => show(index + 1), delay);
        }
      };

      const updateToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-label', manuallyPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.querySelector('[data-pause-icon]').hidden = manuallyPaused;
        toggle.querySelector('[data-play-icon]').hidden = !manuallyPaused;
      };

      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
        show(dotIndex);
        play();
      }));
      toggle?.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        updateToggle();
        manuallyPaused ? stop() : play();
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', (event) => {
        if (!hero.contains(event.relatedTarget)) play();
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : play());
      reduceMotion.addEventListener?.('change', play);
      play();
    };

    document.querySelectorAll('[data-homepage-hero]').forEach(initializeHero);
    document.addEventListener('shopify:section:load', (event) => initializeHero(event.target.querySelector('[data-homepage-hero]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-faq-search]').forEach((form) => {
      const input = form.querySelector('[data-faq-search-input]');
      const section = form.closest('.yoria-faq-section');
      const items = [...section.querySelectorAll('[data-faq-item]')];
      const empty = section.querySelector('[data-faq-empty]');
      section.querySelectorAll('.yoria-faq-section__popular a').forEach((link) => {
        link.addEventListener('click', () => {
          const target = section.querySelector(link.getAttribute('href'));
          if (target) target.open = true;
        });
      });
      const filter = () => {
        const query = input.value.trim().toLocaleLowerCase();
        const synonymGroups = [
          ['配送', '配達', '発送', '送料', '届く', 'delivery', 'shipping', 'postage'],
          ['防水', '水洗い', '洗浄', 'お手入れ', 'waterproof', 'wash', 'clean', 'care'],
          ['返品', '交換', 'キャンセル', '保証', 'return', 'exchange', 'cancel', 'warranty'],
          ['初心者', '初めて', 'はじめて', 'first', 'beginner', 'new'],
          ['静音', '音', 'quiet', 'noise', 'silent'],
          ['吸引', 'エアパルス', 'suction', 'air pulse'],
          ['振動', 'バイブ', 'vibration', 'vibrator'],
          ['梱包', '匿名', 'プライバシー', 'package', 'packaging', 'privacy', 'discreet']
        ];
        const relatedGroup = synonymGroups.find((group) => group.some((term) => term.includes(query) || query.includes(term)));
        const searchTerms = query && relatedGroup ? relatedGroup : [query];
        let visible = 0;
        items.forEach((item) => {
          const itemText = item.textContent.toLocaleLowerCase();
          const match = !query || searchTerms.some((term) => itemText.includes(term));
          item.hidden = !match;
          if (match) visible += 1;
        });
        section.querySelectorAll('.yoria-faq-section__group').forEach((group) => {
          group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
        });
        empty.hidden = visible > 0;
      };
      const initialQuery = new URL(window.location.href).searchParams.get('faq_q');
      if (initialQuery) input.value = initialQuery;
      filter();
      input.addEventListener('input', filter);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filter();
        const url = new URL(window.location.href);
        input.value.trim() ? url.searchParams.set('faq_q', input.value.trim()) : url.searchParams.delete('faq_q');
        window.history.replaceState({}, '', url);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-carousel]').forEach((root) => {
      const track = root.querySelector('[data-product-track]');
      if (!track) return;
      const previousButton = root.querySelector('[data-product-prev]');
      const nextButton = root.querySelector('[data-product-next]');
      const interact = (direction) => track.scrollBy({ left: direction * Math.max(240, track.clientWidth * .75), behavior: 'smooth' });
      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const isScrollable = maxScroll > 2;
        const isAtStart = track.scrollLeft <= 2;
        const isAtEnd = track.scrollLeft >= maxScroll - 2;
        root.classList.toggle('is-scrollable', isScrollable);
        root.classList.toggle('is-at-start', isAtStart);
        root.classList.toggle('is-at-end', isAtEnd);
        if (previousButton) previousButton.disabled = !isScrollable || isAtStart;
        if (nextButton) nextButton.disabled = !isScrollable || isAtEnd;
      };
      previousButton?.addEventListener('click', () => interact(-1));
      nextButton?.addEventListener('click', () => interact(1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      requestAnimationFrame(update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const search = document.querySelector('[data-search-overlay]');
    if (search) document.body.appendChild(search);
    let searchOpener = null;
    const syncScrollLock = () => { document.body.style.overflow = search && !search.hidden ? 'hidden' : ''; };
    const focusFirst = (container) => { container?.querySelector('input,button,a,select,[tabindex]:not([tabindex="-1"])')?.focus(); };
    const trapFocus = (event, container) => {
      if (event.key !== 'Tab' || !container || container.hidden) return;
      const focusable = [...container.querySelectorAll('a,button,input,select,[tabindex]:not([tabindex="-1"])')].filter((item) => !item.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    const closeSearch = () => { if (!search) return; search.hidden = true; syncScrollLock(); searchOpener?.focus(); };
    document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', () => {
      if (!search) return;
      searchOpener = button;
      search.hidden = false;
      syncScrollLock();
      search.querySelector('[data-search-input]')?.focus();
    }));
    search?.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (event) => {
      if (search && !search.hidden) { trapFocus(event, search); if (event.key === 'Escape') closeSearch(); return; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => { document.querySelectorAll('[data-yoria-hero]').forEach((hero) => { const slides = [...hero.querySelectorAll('[data-hero-slide]')]; const dots = [...hero.querySelectorAll('[data-hero-dot]')]; const count = hero.querySelector('[data-hero-count]'); if (slides.length < 2) return; let index = 0; let timer; const set = (next) => { index = (next + slides.length) % slides.length; slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index)); dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index)); if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`; }; const play = () => { clearInterval(timer); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => set(index + 1), 6000); }; dots.forEach((dot, i) => dot.addEventListener('click', () => { set(i); play(); })); hero.addEventListener('mouseenter', () => clearInterval(timer)); hero.addEventListener('mouseleave', play); hero.addEventListener('touchstart', () => clearInterval(timer), { passive: true }); hero.addEventListener('touchend', play, { passive: true }); play(); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.yoria-article').forEach((article) => {
      const content = article.querySelector('.yoria-article__content');
      const toc = article.querySelector('[data-article-toc]');
      const list = article.querySelector('[data-article-toc-list]');
      if (!content || !toc || !list) return;
      const headings = [...content.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.hidden = headings.length === 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => { document.querySelectorAll('[data-cart-quantity]').forEach((control) => { const input = control.querySelector('[data-quantity-input]'); const form = input?.closest('form'); const updateButton = form?.querySelector('[data-cart-update]'); if (!input || !form || !updateButton) return; let timer; const submit = () => { clearTimeout(timer); timer = setTimeout(() => form.requestSubmit(updateButton), 350); }; const change = (amount) => { input.value = Math.max(0, Number(input.value || 0) + amount); submit(); }; control.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => change(-1)); control.querySelector('[data-quantity-increase]')?.addEventListener('click', () => change(1)); input.addEventListener('change', submit); control.parentElement.querySelector('[data-cart-remove]')?.addEventListener('click', () => { input.value = 0; form.requestSubmit(updateButton); }); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection-section]').forEach((section) => {
      const params = new URLSearchParams(window.location.search);
      const priceMin = params.get('filter.v.price.gte') || '';
      const priceMax = params.get('filter.v.price.lte') || '';
      section.querySelectorAll('[data-price-min]').forEach((link) => {
        if (link.dataset.priceMin === priceMin && link.dataset.priceMax === priceMax) link.setAttribute('aria-current', 'true');
      });
      const toggle = section.querySelector('[data-filter-toggle]');
      if (!toggle) return;
      const panel = section.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (!panel) return;
      const backdrop = section.querySelector('[data-filter-backdrop]');
      const mobileQuery = window.matchMedia('(max-width: 767px)');
      const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])';
      let previousBodyOverflow = '';
      const getFocusableElements = () => [...panel.querySelectorAll(focusableSelector)]
        .filter((element) => element.getClientRects().length > 0);
      const close = (restoreFocus = true) => {
        panel.classList.remove('is-open');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        backdrop?.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = previousBodyOverflow;
        if (restoreFocus && mobileQuery.matches) toggle.focus();
      };
      toggle.addEventListener('click', () => {
        const open = panel.classList.toggle('is-open');
        backdrop?.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (open) {
          previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          const firstFocusable = getFocusableElements()[0];
          if (firstFocusable) firstFocusable.focus();
          else panel.focus();
        } else {
          close();
        }
      });
      panel.querySelector('[data-filter-close]')?.addEventListener('click', () => close());
      backdrop?.addEventListener('click', () => close());
      document.addEventListener('keydown', (event) => {
        if (!panel.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) {
          event.preventDefault();
          panel.focus();
          return;
        }
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        } else if (!panel.contains(document.activeElement)) {
          event.preventDefault();
          firstFocusable.focus();
        }
      });
      mobileQuery.addEventListener('change', (event) => {
        if (!event.matches && panel.classList.contains('is-open')) close(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-yoria-product]');
    roots.forEach((root) => {
      const campaignEnabled = root.dataset.campaignDiscountEnabled === 'true';
      const campaignCode = root.dataset.campaignDiscountCode || '';
      let campaignActive = root.dataset.campaignDiscountActive === 'true';
      const campaignPriceMarkup = (originalPrice, discountedPrice) => `<s class="yoria-price__compare">${originalPrice}</s><span class="yoria-price__sale">${discountedPrice}</span><small class="yoria-price__campaign-label">${root.dataset.campaignDiscountLabel}</small>`;
      const renderCampaignPrice = () => {
        const selectedInput = [...root.querySelectorAll('[data-product-variant-input]')].find((input) => input.checked);
        const originalPrice = selectedInput?.dataset.price || root.dataset.currentPrice;
        const discountedPrice = selectedInput?.dataset.campaignPrice || root.dataset.campaignPrice;
        root.querySelectorAll('.yoria-price').forEach((price) => {
          price.classList.add('yoria-price--campaign');
          price.innerHTML = campaignPriceMarkup(originalPrice, discountedPrice);
        });
      };
      const applyCampaignDiscount = async () => {
        if (!campaignEnabled || !campaignCode) return;
        try {
          if (window.YoriaCampaign) {
            await window.YoriaCampaign.ensure();
            renderCampaignPrice();
            return;
          }
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: campaignCode, attributes: { yoria_campaign_discount: campaignCode } }),
          });
          if (!response.ok) throw new Error(`Discount request failed with ${response.status}`);
          const cart = await response.json();
          const saved = cart.discount_codes?.some((discount) => discount.code?.toLowerCase() === campaignCode.toLowerCase());
          if (!saved) throw new Error('Discount code was not saved to the cart');
          campaignActive = true;
          root.dataset.campaignDiscountActive = 'true';
          try { localStorage.setItem('yoria-campaign-discount', campaignCode); } catch {}
          renderCampaignPrice();
        } catch (error) {
          console.error(error);
        }
      };
      const campaignReady = applyCampaignDiscount();
      const mediaItems = root.querySelectorAll('[data-product-media]');
      const thumbs = root.querySelectorAll('[data-product-thumb]');
      const activateMedia = (index) => {
        mediaItems.forEach((media) => {
          const isActive = media.getAttribute('data-product-media') === index;
          media.hidden = !isActive;
          if (!isActive) media.querySelector('video')?.pause();
        });
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.getAttribute('data-product-thumb') === index));
      };
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          activateMedia(thumb.getAttribute('data-product-thumb'));
        });
      });

      const quantity = root.querySelector('[data-product-quantity]');
      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantity) return;
          const nextValue = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange));
          quantity.value = String(nextValue);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      const form = root.querySelector('.yoria-product__form');
      const directCheckout = root.querySelector('[data-direct-checkout]');
      const directCheckoutError = root.querySelector('[data-product-direct-checkout-error]');
      if (form && directCheckout) {
        form.addEventListener('submit', async (event) => {
          if (event.submitter !== directCheckout) return;
          if (!form.reportValidity()) return;
          event.preventDefault();
          directCheckout.disabled = true;
          directCheckout.setAttribute('aria-busy', 'true');
          if (directCheckoutError) directCheckoutError.hidden = true;
          try {
            await campaignReady;
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            });
            if (!response.ok) throw new Error(`Direct checkout failed with ${response.status}`);
            const checkoutPath = `${window.Shopify?.routes?.root || '/'}checkout`;
            window.location.assign(window.YoriaCampaign ? window.YoriaCampaign.discountUrl(checkoutPath) : checkoutPath);
          } catch (error) {
            console.error(error);
            directCheckout.disabled = false;
            directCheckout.removeAttribute('aria-busy');
            if (directCheckoutError) directCheckoutError.hidden = false;
          }
        });
      }

      const wishlist = root.querySelector('[data-product-wishlist]');
      if (wishlist) {
        const storageKey = 'yoria-wishlist';
        const readWishlist = () => {
          try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { return []; }
        };
        const renderWishlist = () => {
          const active = readWishlist().includes(wishlist.dataset.productId);
          wishlist.setAttribute('aria-pressed', String(active));
          wishlist.querySelector('[data-wishlist-label]').textContent = active ? wishlist.dataset.removeLabel : wishlist.dataset.addLabel;
          wishlist.querySelector('[aria-hidden="true"]').textContent = active ? '♥' : '♡';
        };
        wishlist.addEventListener('click', () => {
          const saved = readWishlist();
          const productId = wishlist.dataset.productId;
          const next = saved.includes(productId) ? saved.filter((id) => id !== productId) : [...saved, productId];
          try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch {}
          renderWishlist();
        });
        renderWishlist();
      }

      const labels = root.querySelector('[data-product-labels]');
      const variantInputs = root.querySelectorAll('[data-product-variant-input]');
      if (variantInputs.length) {
        const updateVariant = () => {
          const input = [...variantInputs].find((variantInput) => variantInput.checked);
          if (!input) return;
          const available = input.dataset.available === 'true';
          const inventoryManaged = Boolean(input.dataset.inventoryManagement);
          const inStock = !inventoryManaged || Number(input.dataset.inventoryQuantity) > 0;
          const hasShippingExpectation = Boolean(labels?.dataset.shippingExpectation);
          const inventoryState = inStock ? 'in-stock' : (hasShippingExpectation ? 'preorder' : 'out-of-stock');
          const variantMedia = input.dataset.mediaId
            ? root.querySelector(`[data-product-media-id="${CSS.escape(input.dataset.mediaId)}"][data-product-media]`)
            : null;
          if (variantMedia) activateMedia(variantMedia.getAttribute('data-product-media'));
          const priceMarkup = campaignActive
            ? campaignPriceMarkup(input.dataset.price, input.dataset.campaignPrice)
            : input.dataset.comparePrice && input.dataset.comparePrice !== input.dataset.price
              ? `<span class="yoria-price__sale">${input.dataset.price}</span><s class="yoria-price__compare">${input.dataset.comparePrice}</s>`
              : `<span>${input.dataset.price}</span>`;
          root.querySelectorAll('.yoria-price').forEach((price) => {
            price.classList.toggle('yoria-price--campaign', campaignActive);
            price.innerHTML = priceMarkup;
          });
          root.querySelectorAll('[data-product-submit], [data-product-sticky-submit]').forEach((button) => {
            button.disabled = !available;
            button.textContent = available ? labels?.dataset.addLabel : labels?.dataset.soldOutLabel;
          });
          root.querySelectorAll('[data-direct-checkout]').forEach((button) => {
            button.disabled = !available;
            button.textContent = available ? labels?.dataset.buyNowLabel : labels?.dataset.soldOutLabel;
          });
          const mainStock = root.querySelector('[data-product-stock]');
          if (mainStock) {
            mainStock.classList.remove('is-in-stock', 'is-preorder', 'is-out-of-stock');
            mainStock.classList.add(`is-${inventoryState}`);
            const heading = mainStock.querySelector('[data-product-stock-heading]');
            const separator = mainStock.querySelector('[data-product-stock-separator]');
            const detail = mainStock.querySelector('[data-product-stock-detail]');
            if (heading) {
              heading.textContent = inventoryState === 'in-stock'
                ? labels?.dataset.inStockLabel
                : inventoryState === 'preorder'
                  ? labels?.dataset.preorderLabel
                  : labels?.dataset.outOfStockLabel;
            }
            if (separator) separator.hidden = inventoryState === 'out-of-stock';
            if (detail) {
              detail.hidden = inventoryState === 'out-of-stock';
              detail.textContent = inventoryState === 'in-stock'
                ? labels?.dataset.shippingSpeedLabel
                : inventoryState === 'preorder'
                  ? labels?.dataset.shippingExpectation
                  : '';
            }
          }
          const stickyStock = root.querySelector('[data-product-sticky-stock]');
          if (stickyStock) {
            stickyStock.textContent = inventoryState === 'in-stock'
              ? labels?.dataset.inStockLabel
              : inventoryState === 'preorder'
                ? labels?.dataset.preorderLabel
                : labels?.dataset.outOfStockLabel;
          }
          const payment = root.querySelector('[data-product-payment]');
          if (payment) payment.hidden = !available;
        };
        variantInputs.forEach((input) => input.addEventListener('change', updateVariant));
        updateVariant();
      } else if (campaignActive) {
        renderCampaignPrice();
      }

      const sticky = root.querySelector('[data-product-sticky]');
      if (!sticky) return;
      const summary = root.querySelector('.yoria-product__summary');
      let summaryHasFocus = false;
      const onScroll = () => { sticky.hidden = window.scrollY < 520 || summaryHasFocus; };
      summary?.addEventListener('focusin', () => {
        summaryHasFocus = true;
        onScroll();
      });
      summary?.addEventListener('focusout', () => {
        window.setTimeout(() => {
          summaryHasFocus = summary.contains(document.activeElement);
          onScroll();
        });
      });
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-first-time-support"]) return;
  try {
    
  (() => {
    const bindFirstTimeCta = (section) => {
      const valueButton = section.querySelector('[data-product-first-time-submit]');
      if (!valueButton || valueButton.dataset.bound === 'true') return;
      const mainButton = document.querySelector('[data-product-submit]');
      if (!mainButton) {
        valueButton.disabled = true;
        return;
      }
      const syncButton = () => {
        valueButton.disabled = mainButton.disabled;
        valueButton.textContent = mainButton.textContent.trim();
      };
      valueButton.dataset.bound = 'true';
      valueButton.addEventListener('click', () => mainButton.click());
      new MutationObserver(syncButton).observe(mainButton, { attributes: true, childList: true, subtree: true });
      syncButton();
    };
    document.querySelectorAll('[data-product-first-time-support]').forEach(bindFirstTimeCta);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-product-first-time-support]')) bindFirstTimeCta(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindStoryCta = (section) => {
      const storyButton = section.querySelector('[data-product-story-submit]');
      if (!storyButton || storyButton.dataset.bound === 'true') return;

      const mainButton = document.querySelector('[data-product-submit]');
      if (!mainButton) {
        storyButton.disabled = true;
        return;
      }

      const syncButton = () => {
        storyButton.disabled = mainButton.disabled;
        storyButton.textContent = mainButton.textContent.trim();
      };

      storyButton.dataset.bound = 'true';
      storyButton.addEventListener('click', () => mainButton.click());
      new MutationObserver(syncButton).observe(mainButton, { attributes: true, childList: true, subtree: true });
      syncButton();
    };

    document.querySelectorAll('[data-product-story]').forEach(bindStoryCta);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-product-story]')) bindStoryCta(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
